import { MapPin, Armchair, Beer, Sparkles, HeartPulse, Gift } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const icons = [MapPin, Armchair, Beer, HeartPulse, Gift, Sparkles];

export function Practical() {
  const { t } = useI18n();
  const cards = t.practical.cards.map((c, i) => ({ ...c, icon: icons[i] ?? MapPin }));
  return (
    <section id="praktisch" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl">
          <p className="font-mono-cinema text-[10px] text-gold">{t.practical.eyebrow}</p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-[1.05] md:text-5xl lg:text-6xl">
            {t.practical.title1}
            <span className="block italic text-gold">{t.practical.title2}</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c) => (
            <div
              key={c.title}
              className="group rounded-2xl border border-border bg-card p-7 transition-all duration-300 hover:-translate-y-0.5 hover:border-gold/40 hover:shadow-soft"
            >
              <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-lg bg-gold/10 text-gold transition-colors group-hover:bg-gradient-gold group-hover:text-gold-foreground">
                <c.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl">{c.title}</h3>
              <ul className="mt-3 space-y-1.5 text-sm text-foreground/65">
                {c.lines.map((l) => (
                  <li key={l}>{l}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
